let dd = require("ES/lib/dd");
let React = require("ES/lib/react");
// let Tripit = require("./Tripit");
let AwardWallet = require("./AwardWallet");
let ProOnly = require("../../../../widgets/ProOnly");
let esUtils = require("ES/utils/esUtils");
let Itinerary = require("./Itinerary");
let TravelNotes = require("./TravelNotes");
let AuthedUserSession = require("../../../../../utils/AuthedUserSession");
let isEventAccountingLockedForMe = require("../../../../../utils/isEventAccountingLockedForMe");

module.exports = dd.createClass({
    __print: esUtils.wrapPreventDefault(function () {
        let {event} = this.props;
        window.open("/reports/loader.php?" + esUtils.phpCompatibleParams({
                report: "eventtravel.php",
                eid: event.eid,
                inc_air: "",
                inc_ground: "",
                inc_hotel: "",
                inc_travelnotes: "",
                output_format: "html"
            }), "esReportWindow", "height=600,width=1024").focus();
    }),
    render(){
        let {event, Displaylists} = this.props;

        let read_only = AuthedUserSession.doIHaveAccess.read.any(event.sids) || isEventAccountingLockedForMe(event);

        return dd.div({className: "Travel"},
            ProOnly({
                    sids: event.sids,
                    custom_message: "Attach air, ground and hotel plans right to the event so everyone is in sync. Import plans from TripIt or type in, then ease worried clients with the \"Event Travel\" report."
                },
                read_only ? null : dd.div({className: "pull-right"},
                  AwardWallet({event, Displaylists})
                ),
                // /* TripIt has deprecated their API, so we do not use it anymore - mh June 2024 */
                // read_only ? null : dd.div({className: "pull-right"},
                //         Tripit({event, Displaylists})
                //     ),
                dd.h2(null, "Travel"),
                dd.div({className: "clearfix"}),
                event.is_mp_event
                    ? <div>
                        <p className="instruction">
                            Travel plans are shared automatically with the client through eSpeakers Marketplace.
                        </p>
                    </div>
                    : null,
                dd.h4({className: "section-head"},
                    "Itinerary",
                    dd.a({href: "#", className: "pull-right printlink", onClick: this.__print}, dd.i({className: "fa fa-print"}), " print")
                ),
                Itinerary({event, Displaylists, read_only}),

                TravelNotes({event, Displaylists, read_only, form_section_name: "Notes"})
            )
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/travel/index.js